module.exports = __webpack_public_path__ + "img/icon-table-black.16c48792.svg";